import { render, staticRenderFns } from "./CourseStudy.vue?vue&type=template&id=27a835fd&scoped=true&"
import script from "./CourseStudy.vue?vue&type=script&lang=js&"
export * from "./CourseStudy.vue?vue&type=script&lang=js&"
import style0 from "./CourseStudy.vue?vue&type=style&index=0&id=27a835fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a835fd",
  null
  
)

export default component.exports